/* NMN|PP|AB34 — Ready Name alternative card for Custom Name Necklace PDP
   Single IIFE, paste-ready into Varify.io variant code editor. */
(function () {
  'use strict';

  // ---- Idempotency: clean up any prior injection -----------------------------
  document.querySelectorAll('[data-ab34]').forEach(function (n) { n.remove(); });
  if (window.__AB34_INIT__) {
    // Previous run installed listeners on nodes that may still exist.
    // We re-attach below; the previous closures will simply no-op since
    // their DOM target (the card) is gone and render() rebuilds from scratch.
  }
  window.__AB34_INIT__ = true;

  // ---- Path guard ------------------------------------------------------------
  if (!location.pathname.startsWith('/products/custom-name-necklace')) return;

  // ---- Constants -------------------------------------------------------------
  var READY_NAME_PRODUCT_URL = 'https://nominalx.com/products/arabic-name-necklace-a-to-m';
  var READY_NAME_THUMBNAIL   = 'https://cdn.shopify.com/s/files/1/2556/8900/files/ready-names.png?v=1779136438';

  var READY_NAMES = [
    { display: 'Sara',    variants: ['sara', 'sarah'] },
    { display: 'Layla',   variants: ['layla', 'laila'] },
    { display: 'Aisha',   variants: ['aisha', 'ayesha'] },
    { display: 'Maryam',  variants: ['maryam', 'mariam'] },
    { display: 'Aya',     variants: ['aya'] },
    { display: 'Hana',    variants: ['hana', 'hanna'] },
    { display: 'Nadia',   variants: ['nadia'] },
    { display: 'Salma',   variants: ['salma'] },
    { display: 'Khadija', variants: ['khadija'] }
  ];

  // ---- Styles ----------------------------------------------------------------
  var CSS = [
    '.ab34-readyname-card,.ab34-readyname-card *{',
      'box-sizing:border-box !important;',
      'float:none !important;',
      'position:static !important;',
      'max-width:100% !important;',
      'min-width:0 !important;',
    '}',
    '.ab34-readyname-card{',
      'display:flex !important;',
      'flex-direction:column !important;',
      'align-items:stretch !important;',
      'gap:16px !important;',
      'width:auto !important;',
      'max-width:100% !important;',
      'min-width:0 !important;',
      'padding:12px !important;',
      'margin:12px 0 0 0 !important;',
      'background:linear-gradient(0deg,rgba(255,255,255,0.9),rgba(255,255,255,0.9)),#C8A983 !important;',
      'border:1.5px solid rgba(159,117,91,0.2) !important;',
      'border-radius:4px !important;',
      'font-family:"Instrument Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif !important;',
      'color:#1C1B1B !important;',
      'line-height:1.4 !important;',
      'text-align:left !important;',
    '}',
    '.ab34-readyname-card .ab34-top{',
      'display:flex !important;',
      'flex-direction:row !important;',
      'align-items:center !important;',
      'gap:12px !important;',
      'width:auto !important;',
      'min-width:0 !important;',
    '}',
    '.ab34-readyname-card .ab34-thumb{',
      'flex:0 0 107px !important;',
      'width:107px !important;',
      'height:107px !important;',
      'border-radius:2px !important;',
      'background-color:#FFFFFF !important;',
      'background-image:url("' + READY_NAME_THUMBNAIL + '") !important;',
      'background-size:cover !important;',
      'background-position:center !important;',
      'background-repeat:no-repeat !important;',
    '}',
    '.ab34-readyname-card .ab34-body{',
      'flex:1 1 0% !important;',
      'min-width:0 !important;',
      'display:flex !important;',
      'flex-direction:column !important;',
      'justify-content:center !important;',
      'align-items:stretch !important;',
      'gap:10px !important;',
    '}',
    '.ab34-readyname-card .ab34-eyebrow{',
      'display:block !important;',
      'width:auto !important;',
      'min-width:0 !important;',
      'margin:0 !important;',
      'padding:0 !important;',
      'font-family:"Instrument Sans",sans-serif !important;',
      'font-weight:400 !important;',
      'font-size:14px !important;',
      'line-height:1.2 !important;',
      'text-transform:uppercase !important;',
      'color:#9F755B !important;',
      'letter-spacing:0.02em !important;',
      'white-space:normal !important;',
      'overflow-wrap:break-word !important;',
    '}',
    '.ab34-readyname-card .ab34-msg{',
      'display:block !important;',
      'width:auto !important;',
      'min-width:0 !important;',
      'margin:0 !important;',
      'padding:0 !important;',
      'font-family:"Instrument Sans",sans-serif !important;',
      'font-weight:400 !important;',
      'font-size:12px !important;',
      'line-height:1.6 !important;',
      'color:#666666 !important;',
      'word-break:normal !important;',
      'overflow-wrap:anywhere !important;',
    '}',
    '.ab34-readyname-card .ab34-msg strong{',
      'font-weight:700 !important;',
      'color:#1C1B1B !important;',
      'background:transparent !important;',
    '}',
    '.ab34-readyname-card .ab34-msg .ab34-name,',
    '.ab34-readyname-card a.ab34-name:link,',
    '.ab34-readyname-card a.ab34-name:visited,',
    '.ab34-readyname-card a.ab34-name:hover,',
    '.ab34-readyname-card a.ab34-name:active{',
      'color:#9F755B !important;',
      'font-weight:700 !important;',
      'text-decoration:underline !important;',
      'text-underline-offset:2px !important;',
      'background:transparent !important;',
      'cursor:pointer !important;',
    '}',
    '.ab34-readyname-card .ab34-cta-row{',
      'display:flex !important;',
      'flex-direction:row !important;',
      'align-items:stretch !important;',
      'gap:4px !important;',
      'width:auto !important;',
      'min-width:0 !important;',
      'margin:0 !important;',
      'padding:0 !important;',
    '}',
    '.ab34-readyname-card .ab34-cta{',
      'flex:1 1 0 !important;',
      'min-width:0 !important;',
      'max-width:100% !important;',
      'display:inline-flex !important;',
      'justify-content:center !important;',
      'align-items:center !important;',
      'height:32px !important;',
      'padding:0 12px !important;',
      'margin:0 !important;',
      'border-radius:3px !important;',
      'font-family:"Instrument Sans",sans-serif !important;',
      'font-weight:600 !important;',
      'font-size:12px !important;',
      'line-height:1.2 !important;',
      'text-align:center !important;',
      'text-decoration:none !important;',
      'text-transform:none !important;',
      'white-space:nowrap !important;',
      'cursor:pointer !important;',
      'user-select:none !important;',
      '-webkit-appearance:none !important;',
      'appearance:none !important;',
      'box-shadow:none !important;',
      'letter-spacing:0 !important;',
    '}',
    '.ab34-readyname-card .ab34-cta--primary,',
    '.ab34-readyname-card a.ab34-cta--primary:link,',
    '.ab34-readyname-card a.ab34-cta--primary:visited{',
      'background:#1C1B1B !important;',
      'color:#FFFFFF !important;',
      'border:1px solid #1C1B1B !important;',
    '}',
    '.ab34-readyname-card .ab34-cta--primary:hover{background:#000 !important;color:#FFFFFF !important;}',
    '.ab34-readyname-card .ab34-cta--secondary{',
      'background:#FFFFFF !important;',
      'color:#1C1B1B !important;',
      'border:1px solid rgba(28,27,27,0.2) !important;',
    '}',
    '.ab34-readyname-card .ab34-cta--secondary:hover{background:#F7F7F7 !important;}',
    '@media (max-width: 767px){',
      '.ab34-readyname-card{gap:16px !important;padding:12px !important;}',
      '.ab34-readyname-card .ab34-top{gap:12px !important;}',
      '.ab34-readyname-card .ab34-thumb{flex:0 0 84px !important;width:84px !important;height:84px !important;}',
      '.ab34-readyname-card .ab34-body{gap:8px !important;}',
      '.ab34-readyname-card .ab34-eyebrow{font-size:13px !important;}',
      '.ab34-readyname-card .ab34-cta{padding:0 8px !important;}',
    '}',
    // Fix iOS Safari auto-zoom on focus.
    // Safari zooms when the focused field's computed font-size is < 16px.
    // Bump every Itoris text input + the specific name input to 16px so
    // tapping any of them does not trigger the zoom that crops the card.
    'html body input#options_1001_text,',
    'html body input.input-text.product-custom-option,',
    'html body #itoris_dynamicproductoptions input[type="text"]{',
      'font-size:16px !important;',
    '}'
  ].join('');

  var styleEl = document.createElement('style');
  styleEl.setAttribute('data-ab34', '');
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  // ---- State -----------------------------------------------------------------
  var dismissed = false;
  var debounceTimer = null;
  var listenersAttached = false;
  var attachedInputNode = null;

  // ---- Helpers ---------------------------------------------------------------
  function matchReadyName(rawValue) {
    var v = (rawValue || '').trim().toLowerCase();
    if (!v) return null;
    for (var i = 0; i < READY_NAMES.length; i++) {
      if (READY_NAMES[i].variants.indexOf(v) !== -1) return READY_NAMES[i];
    }
    return null;
  }

  function isGoldSelected() {
    var checked = document.querySelector('input[name="option-0"]:checked');
    if (!checked) return false;
    var val = checked.value || '';
    return val.indexOf('18K Gold Plated') === 0;
  }

  function isArabicSelected() {
    var checked = document.querySelector('input[name="option-2"]:checked');
    if (!checked) return false;
    return (checked.value || '').trim() === 'Arabic';
  }

  function buildCard(match) {
    var card = document.createElement('div');
    card.className = 'ab34-readyname-card';
    card.setAttribute('data-ab34', '');
    card.setAttribute('role', 'complementary');
    card.setAttribute('aria-label', 'Ready Name alternative');

    var top = document.createElement('div');
    top.className = 'ab34-top';
    card.appendChild(top);

    var thumb = document.createElement('div');
    thumb.className = 'ab34-thumb';
    thumb.setAttribute('aria-hidden', 'true');
    top.appendChild(thumb);

    var body = document.createElement('div');
    body.className = 'ab34-body';
    top.appendChild(body);

    var eyebrow = document.createElement('div');
    eyebrow.className = 'ab34-eyebrow';
    eyebrow.textContent = 'In Ready Names Collection';
    body.appendChild(eyebrow);

    var msg = document.createElement('p');
    msg.className = 'ab34-msg';
    msg.appendChild(document.createTextNode('We already carry ' + match.display + ' as a '));
    var readyPiece = document.createElement('a');
    readyPiece.className = 'ab34-name';
    readyPiece.href = READY_NAME_PRODUCT_URL;
    readyPiece.textContent = 'ready piece';
    msg.appendChild(readyPiece);
    msg.appendChild(document.createTextNode('. Same craftsmanship in '));
    var ships = document.createElement('strong');
    ships.textContent = '2 to 3';
    msg.appendChild(ships);
    msg.appendChild(document.createTextNode(' days instead of 7 to 10.'));
    body.appendChild(msg);

    var ctaRow = document.createElement('div');
    ctaRow.className = 'ab34-cta-row';
    card.appendChild(ctaRow);

    var primary = document.createElement('a');
    primary.className = 'ab34-cta ab34-cta--primary';
    primary.href = READY_NAME_PRODUCT_URL;
    primary.textContent = 'View ready necklace';
    ctaRow.appendChild(primary);

    var secondary = document.createElement('button');
    secondary.className = 'ab34-cta ab34-cta--secondary';
    secondary.type = 'button';
    secondary.textContent = 'Keep custom order';
    secondary.addEventListener('click', function (e) {
      e.preventDefault();
      dismissed = true;
      var node = document.querySelector('.ab34-readyname-card');
      if (node) node.remove();
    });
    ctaRow.appendChild(secondary);

    return card;
  }

  function render() {
    document.querySelectorAll('.ab34-readyname-card').forEach(function (n) { n.remove(); });

    if (dismissed) return;

    var input = document.querySelector('#options_1001_text');
    if (!input) return;
    if (!isGoldSelected()) return;
    if (!isArabicSelected()) return;

    var match = matchReadyName(input.value);
    if (!match) return;

    var note = document.querySelector('#dynamic_option_id_1001 p.note');
    var anchor = note || input;
    if (!anchor || !anchor.parentNode) return;

    var card = buildCard(match);
    anchor.parentNode.insertBefore(card, anchor.nextSibling);
  }

  function attachListeners() {
    var input = document.querySelector('#options_1001_text');
    if (input && input !== attachedInputNode) {
      input.addEventListener('input', function () {
        dismissed = false;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(render, 300);
      });
      attachedInputNode = input;
    }

    if (listenersAttached) return;
    listenersAttached = true;

    // Color + language swatches: delegate so future re-renders still trigger.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && (t.name === 'option-0' || t.name === 'option-2')) {
        dismissed = false;
        render();
      }
    });
  }

  function waitForInputAndInit() {
    if (document.querySelector('#options_1001_text')) {
      attachListeners();
      render();
      return;
    }
    var mo = new MutationObserver(function () {
      if (document.querySelector('#options_1001_text')) {
        attachListeners();
        render();
        // Keep watching: Itoris may swap the input node on variant change.
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForInputAndInit);
  } else {
    waitForInputAndInit();
  }
})();